import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
import { copyTextToClipboard, translation } from '../../../utils/helpers'
// import { hasSubscriptionPermission } from '../../../utils/auth'

// Actions
import { saveStatusNotificationInformation, getStatusNotificationInformation, deleteStatusNotification, addStatusNotification } from '../../../actions/settings'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
// import Text from '../../../shared/elements/text'
import TextArea from '../../../shared/elements/textarea'
import Divider from '../../../shared/elements/divider'
// import { ProductionStatus } from './../../../elements/icons'
import './carownernotification.scss'
import Label from '../../../shared/elements/label'
import Grid from '../../../shared/elements/grid'
import Button from '../../../shared/elements/button'

import CarOwnerNotificationSettings from './Settings/index'

class CarOwnerNotification extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      signature: {}
    }
    this.getStatusNotificationInformation = this.getStatusNotificationInformation.bind(this)
    this.saveStatusNotificationInformation = this.saveStatusNotificationInformation.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.setStateFromRequest = this.setStateFromRequest.bind(this)
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.countText = this.countText.bind(this)
    this.deleteNotification = this.deleteNotification.bind(this)
  }

  componentDidMount () {
    this.getStatusNotificationInformation()
  }

  getStatusNotificationInformation () {
    this.props.getStatusNotificationInformation().then((res) => {
      this.setStateFromRequest(res)
    })
  }
  saveStatusNotificationInformation (id) {
    let setting = this.state.data.find(x => x.Id === id)

    this.props.saveStatusNotificationInformation(setting).then(this.success, this.error)
  }

  setStateFromRequest (res) {
    // could be a splice?
    let signature = res.data.find(x => x.Type === 175)
    let cast = res.data.map(x => { return { ...x, Type: Number(x.Type) } })

    let newState = {
      data: cast,
      signature: signature
    }

    this.setState(newState)
  }
  constructSMS (length, count) {
    let SMS = translation('15')
    return `${length} (${count} ${SMS})`
  }

  countText (value, isSignature) {
    const signatureLength = (this.state.signature && this.state.signature.Text) ? this.state.signature.Text.length : 0
    const SMSCountSignature = Math.ceil(signatureLength / 160)
    if (isSignature) return this.constructSMS(signatureLength, SMSCountSignature)

    if (value === null || value === undefined) {
      return this.constructSMS(0, 0)
    }

    const textLength = value.length
    const textWithSignatureLength = textLength + signatureLength
    const SMSCount = Math.ceil(textLength / 160)
    const SMSCountWithSignature = Math.ceil((textWithSignatureLength) / 160)

    const Message = translation('930')
    const exclusive = this.constructSMS(textLength, SMSCount)

    const InclusiveSignature = translation('18283')
    const inclusive = this.constructSMS(textWithSignatureLength, SMSCountWithSignature)
    return `${Message}: ${exclusive} / ${InclusiveSignature}: ${inclusive}`
  }

  onChange (e, selectedId) {
    e.persist()

    let { name, value, checked, type } = e.target

    this.setState(prevState => {
      let signatureModified

      var newDataState = prevState.data.map(setting => {
        if (setting.Id === Number(name) || setting.Id === selectedId) {
          switch (type) {
            case 'checkbox':
              if (name === 'SMSAllowed') setting.SMSAllowed = checked
              if (name === 'EmailAllowed') setting.EmailAllowed = checked
              break

            case 'select-one':
              if (name === 'NotificationType') setting.Type = value
              if (name === 'Days') {
                if (setting.Offset < 0) {
                  setting.Offset = -Math.abs(value * 24)
                } else {
                  setting.Offset = value * 24
                }
              }
              if (name === 'BeforeAfter') {
                if (value === 'before') {
                  if (setting.Offset === 0) setting.Offset = -24
                  setting.Offset = -Math.abs(setting.Offset)
                } else {
                  setting.Offset = Math.abs(setting.Offset)
                }
              }
              break

            default:
              setting.Text = value
              break
          }

          if (this.state.signature && setting.Id === this.state.signature.Id) signatureModified = setting
        }
        return setting
      })

      return {
        data: newDataState,
        signature: signatureModified !== undefined ? signatureModified : prevState.signature // Incredibly heavy performance burden
      }
    }, () => {
      if (e.target.type === 'checkbox' || e.target.type === 'select-one') {
        this.onBlur(e, selectedId)
      }
    })
  }

  onBlur (e, id) {
    this.saveStatusNotificationInformation(id)
  }

  addNotification () {
    this.props.addStatusNotification().then(this.success, this.error)
  }

  deleteNotification (e, setting) {
    this.props.deleteStatusNotification(setting.Id).then(this.success, this.error)
  }

  error () {
    // Err saving
    window.toastr.error(translation('18190'), translation('216'))
  }

  success (res) {
    this.setStateFromRequest(res)
    // window.toastr.success(translation('18189'), translation('13424'))
  }

  render () {
    const headerGridColsSignature = ['auto']
    const isSignature = true

    /* Omit Signature */
    const filteredData = this.state.data.filter(x => x.Type !== 175)

    return (
      <div className='carownerportal__settings'>
        <Row>
          <Col span={5}>
            <Panel title={18185}>
              <div className='wrap-container'>
                <div className='item-field-group'>
                  <Col span={12}>
                    <Label>{translation(18184)}</Label>
                  </Col>
                </div>
                {this.state && (
                  <CarOwnerNotificationSettings
                    data={filteredData}
                    countText={this.countText}
                    deleteNotification={this.deleteNotification}
                    onChange={this.onChange}
                    onBlur={this.onBlur} />
                )}
              </div>
            </Panel>
          </Col>
          <Col span={1}>
            <Panel title={18308}>
              <Label>{translation(18309)}</Label>
              <Divider noLine />
              <Button size='m' style='link' labelText={translation('18310')} onClick={() => copyTextToClipboard(translation('18311'))} />
              <Button size='m' style='link' labelText={translation('14827')} onClick={() => copyTextToClipboard(translation('19005'))} />
              <Button size='m' style='link' labelText={translation('17880')} onClick={() => copyTextToClipboard(translation('19012'))} />
            </Panel>
            <Panel title={19004}>
              <Button size='m' style='link' labelText={translation(1208)} onClick={() => this.addNotification()} />
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col span={5}>
            <Panel title={18284}>
              {this.state && this.state.signature && (
                <div className='wrap-container'>
                  <div className='submit-text'>
                    <Grid cols={headerGridColsSignature} spacing={1}>
                      <Label>{translation(18285)}</Label>
                    </Grid>
                    <TextArea placeholder={translation(18181)} name='SignatureText'
                      value={this.state.signature.Text === null ? translation(18282) : this.state.signature.Text}
                      onChange={(e => this.onChange(e, this.state.signature.Id))} onBlur={(e) => this.onBlur(e, this.state.signature.Id)} />
                    <div className='txt-count'>
                      {this.countText(this.state.signature.Text, isSignature)}
                    </div>
                  </div>
                </div>
              )}
            </Panel>
          </Col>
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  saveStatusNotificationInformation,
  getStatusNotificationInformation,
  deleteStatusNotification,
  addStatusNotification
})(CarOwnerNotification)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/CarOwnerNotification/index.js